import { render, staticRenderFns } from "./HTMLDescription.vue?vue&type=template&id=28fce385&"
import script from "./HTMLDescription.vue?vue&type=script&lang=js&"
export * from "./HTMLDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports